var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-layout-loading"},[_c('v-spinner',{staticClass:"spinner",attrs:{"line-fg-color":"var(--light-gray)","line-bg-color":"var(--lighter-gray)"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }